'use strict';

var _objectSpread = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var basics = require('multiformats/basics');

function createCodec(name, prefix, encode, decode) {
  return {
    name: name,
    prefix: prefix,
    encoder: {
      name: name,
      prefix: prefix,
      encode: encode
    },
    decoder: {
      decode: decode
    }
  };
}

var string = createCodec('utf8', 'u', function (buf) {
  var decoder = new TextDecoder('utf8');
  return 'u' + decoder.decode(buf);
}, function (str) {
  var encoder = new TextEncoder();
  return encoder.encode(str.substring(1));
});
var ascii = createCodec('ascii', 'a', function (buf) {
  var string = 'a';

  for (var i = 0; i < buf.length; i++) {
    string += String.fromCharCode(buf[i]);
  }

  return string;
}, function (str) {
  str = str.substring(1);
  var buf = new Uint8Array(str.length);

  for (var i = 0; i < str.length; i++) {
    buf[i] = str.charCodeAt(i);
  }

  return buf;
});

var BASES = _objectSpread({
  utf8: string,
  'utf-8': string,
  hex: basics.bases.base16,
  latin1: ascii,
  ascii: ascii,
  binary: ascii
}, basics.bases);

module.exports = BASES;